/**
 * 表紙・特集商品選定依頼確認（グループ長用）画面の部門コードクラス
 *
 * @export ClassCode
 * @class ClassCode
 */
export class ClassCode {
  constructor(
    public classCode: string,
    public className: string,
  ) {}
}
